import { useCallback } from 'react';
import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { useI18nSelector } from 'js/store/hooks';

export const useSetTranslations = () => {
    const translate = useTranslations();
    const showTranslationKeys = useI18nSelector(prop('showTranslationKeys'));

    return useCallback((type) => {
        const apiTranslations = window.Communication?.API?.common?.getDefaultTranslations?.();
        const tKeys = apiTranslations?.[type]?.defaultTranslations || [];
        const tkPrefix = 'playtech.mobile.system.';
        const translations = {
            [type]: {}
        };

        for (const tKey in tKeys) {
            const translationKey = tkPrefix + tKey;
            const translatedText = translate(translationKey);

            translations[type][tKey] = showTranslationKeys
                ? translationKey
                : translatedText === translationKey
                    ? tKeys[tKey]
                    : translatedText;
        }

        if (type === 'chat') {
            window.Communication?.API?.chat?.addTranslations?.(translations[type]);
        } else {
            window.Communication?.API?.inbox?.addTranslations?.(translations[type]);
        }
    }, [translate, showTranslationKeys]);
};
